import React, { useEffect, useRef } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import PropTypes from "prop-types";
import _ from "lodash";
import { buildUrl } from "../../utils/helper";
import { SafeSVG } from "../../svg/SafeSVG";
/**
 * Edit boolean cell component
 * @module
 * @param {func} onChange - Function invoked on change
 * @param {string} dataItem - Data item
 * @param {string} field - Field
 * @param {string} className - TD Class name
 * @param {number} colSpan - Number of columns which cell expands to
 * @param {object} style - Style
 * @param {number} columnIndex - Column index
 * @param {number} level - Level
 * @param {func} render - Render function
 */
export const editBooleanCell = ({ getColumns, isValueChanged }) => {
  const EditBooleanCell = (props) => {
    const { onChange, dataIndex, dataItem, field, tdProps, onDoubleClick } = props;
    const dropdownRef = useRef(null);

    const handleChange = (e) => {
      onChange({
        dataItem: dataItem,
        field: field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
    };

    const column = getColumns().find((item) => item.field === field);
    const dataValue = (dataIndex === -1 ? dataItem.value : (_.get(dataItem, field) ?? ""));

    const trueText = column.trueText || "áno";
    const falseText = column.falseText || "nie";
    const localizedData = [
      { text: trueText, value: true },
      { text: falseText, value: false },
    ];

    let content = null;
    if (field && field.toLowerCase() === "zrus" && !column.trueText && !column.falseText) {
      if (dataValue === true) {
        content = <SafeSVG width="20" height="20" src={buildUrl("assets/icons/toolbar/cancel.svg")} alt="zrus" />;
      }
    } else {
      content = dataValue === true ? trueText : (dataValue === false ? falseText : null);
    }

    useEffect(() => {
      if (dropdownRef.current && dropdownRef.current.element) {
        dropdownRef.current.element.setAttribute("data-testid", "boolean-dropdown");
      }
    }, []);

    return (
      <td
        data-testid="boolean-cell"
        {...tdProps}
        className={`${tdProps.className} ${isValueChanged && isValueChanged(dataItem, field) ? "k-state-changed" : ""}`}
        tabIndex={0}
        onDoubleClick={onDoubleClick}
      >
        {props.isInEdit && column.editable !== false ? (
          <DropDownList
            ref={dropdownRef}
            onChange={handleChange}
            value={localizedData.find((c) => c.value === dataValue)}
            data={localizedData}
            textField="text"
          />
        ) : (
          content
        )}
      </td>
    );
  };

  EditBooleanCell.propTypes = {
    onChange: PropTypes.func,
    dataItem: PropTypes.object,
    field: PropTypes.string,
    className: PropTypes.string,
    colSpan: PropTypes.number,
    style: PropTypes.object,
    columnIndex: PropTypes.number,
    level: PropTypes.number,
    render: PropTypes.func,
  };

  return EditBooleanCell;
};
